/* global globalThis */
import URL from "./apiURL";
import { getValidToken } from "../../utils/getValidToken";

export async function exportTicketReport(payload) {


  try {
    const token = await getValidToken();
    const response = await fetch(URL.exportTicketReport, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    
    const blob = await response.blob();    

    const url = globalThis.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Change_Management_Report_${Date.now()}.xlsx`);
    document.body.appendChild(link);
    link.click();

    link.remove();
    globalThis.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}


